var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticClass:"text-center text-danger"},[_vm._v(" "+_vm._s(_vm.$t("commons.label.forbidden"))+" ")]),_c('h6',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t("commons.label.403_title")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }